import { render, staticRenderFns } from "./FormTextblockElement.vue?vue&type=template&id=4df17a06&scoped=true"
import script from "./FormTextblockElement.vue?vue&type=script&lang=js"
export * from "./FormTextblockElement.vue?vue&type=script&lang=js"
import style0 from "./FormTextblockElement.vue?vue&type=style&index=0&id=4df17a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df17a06",
  null
  
)

export default component.exports